import React from 'react'
import './contact.css'
import {TfiEmail} from 'react-icons/tfi'
import {GrInstagram} from 'react-icons/gr'
import {BsWhatsapp}  from 'react-icons/bs'
import { useRef } from 'react';
import emailjs from 'emailjs-com'


const Contact = () => {


  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_305ckpo', 'template_vec5hme', form.current, '9qrxbi4XspqhL97K6')
    e.target.reset()
      
  };

  return (
    <section id='contact'>
      <h5 color-light >Get In Touch</h5>
      <h2>Contact Me</h2>
      <div className="container contact__container">

        <div className="contact__options">
          <article className='contact__option'>
            <TfiEmail className='contact__option-icon'/>
            <h4>Email</h4>
            <h5>Markpaulmuthaura@gmail.com</h5>
            <a href="mailto:Markpaulmuthaura@gmail.com" target="_blank">Send a message</a>

          </article>
          <article className='contact__option'>
            <GrInstagram className='contact__option-icon'/>
            <h4>Instagram</h4>
            <h5>Markpaul</h5>
            <a href="https://www.instagram.com/muthaura_jr" target="_blank">Send a message</a>

          </article>
          <article className='contact__option'>
            <BsWhatsapp className='contact__option-icon'/>
            <h4>WhatsApp</h4>
            <h5>Text</h5>
            <a href="https://wa.me/+254742903527" target="_blank">Send a message</a>

          </article>

        </div>
        {/* END OF CONTACT OPTIONS */}
        <form ref={form} onSubmit={sendEmail}>
          <input type="text" name="name" placeholder='Your Full Name' required/>
          <input type="email" name="email" placeholder='Your Email' required />
          <textarea name="message" rows="7" placeholder='Your Message' required></textarea>
          <button type='submit' className='btn btn-primary'>Send Message</button>
        </form>
      </div>
 
    </section>
  )
}

export default Contact
